import { render, staticRenderFns } from "./LmDocumentTypesListbuilder.vue?vue&type=template&id=1a9c7720&"
import script from "./LmDocumentTypesListbuilder.vue?vue&type=script&lang=js&"
export * from "./LmDocumentTypesListbuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports